import { Company } from '@core/interfaces/company';
import { Attendance } from '../interfaces/attendance';

/**
 * Company whose WhatsApp credits wallet pays for this attendance's messages.
 *
 * `currentCompany` changes when the bot navigates to another company (e.g. a
 * hotel group), but the WhatsApp number stays the one of the company that
 * created the contact channel. So when the current company has no WhatsApp
 * credits of its own, fall back to the contact channel's company — same idea
 * as livechat-api's SendPlatformService.chooseUrlPlatform.
 *
 * Anything we can't confirm (current company unknown to the user, or the
 * channel company missing from the payload) keeps the current company, i.e.
 * the previous behavior.
 */
export function resolveCreditsCompanyId(
  attendance: Pick<Attendance, 'currentCompany' | 'currentContactChannel'> | null | undefined,
  companies: Company[] | null | undefined
): string | undefined {
  const currentCompanyId = attendance?.currentCompany?.id;
  const channelCompanyId = attendance?.currentContactChannel?.companyId;

  if (!channelCompanyId || channelCompanyId === currentCompanyId) {
    return currentCompanyId;
  }

  const currentCompany = companies?.find(
    (company) => company.companyId === currentCompanyId
  );

  if (!currentCompany || currentCompany.hasWhatsappCredits) {
    return currentCompanyId;
  }

  return channelCompanyId;
}
